import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { User } from '../models/auth';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  private networkStatus = new Subject<boolean>();

  menuLoaded = new BehaviorSubject<any>(false);
  generalRefreshDetails = new BehaviorSubject<boolean>(false);

  actionsPermissions = new BehaviorSubject<any>(null);
  updateActionsPermissions = new Subject();

  public currentUserSubject: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);


  SignalRConnectionId = new BehaviorSubject<any>(null);

  constructor(
    private readonly http: HttpClient,
    private router: Router,
  ) {
    const authLS = localStorage.getItem('authUser');
    const ls = authLS ? JSON.parse(authLS) as User : '';
    if (ls) {
      ls.UserRoles = this.decryptPermissions(ls.UserRoles);
      this.currentUserSubject.next(ls);
    }
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }
  public get currentActionsPermissions(): any {
    return this.actionsPermissions.value;
  }

  encryptPermissions(permissions: string[]) {
    const encryptedPermissions: string[] = [];
    permissions.forEach(element => {
      encryptedPermissions.push(element);
    });
    return encryptedPermissions;
  }

  decryptPermissions(permissions: string[]) {
    const decriptedPermissions: string[] = [];
    if (permissions.length) {
      permissions.forEach(element => {
        if (element) {
          decriptedPermissions.push(element);
        }
      });
    }
    return decriptedPermissions;
  }




  login(data: any): any {
    return this.http.post<User>(
      `${environment.apiUrl}/Authenticate/login`, data)
      .pipe(map((user: User) => {
        this.currentUserSubject.next(user);
        this.saveUserSession(user);
      }));
  }
  saveUserSession(user: User) {
    const curenrtUserValue = { ...user };
    curenrtUserValue.UserRoles = this.encryptPermissions(curenrtUserValue?.UserRoles || []);
    localStorage.setItem('authUser', JSON.stringify(curenrtUserValue));
    this.handleLoginRedirct();
  }
  handleLoginRedirct() {
    let user = this.currentUserSubject.value;
    let baseRoute = '/admin';
    this.router.navigate([baseRoute]);
  }
  logout() {
    this.clearUserData();
    this.router.navigate(['/login']);
  }
  clearUserData() {
    localStorage.removeItem('authUser');
    this.currentUserSubject.next(null);
  }

  // Verification APIs
  ChangePassword(password: string, userID: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/ChangePassword`, { password, userID, token });
  }
  verifyToken(userId: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/VerifyToken`, { userId, token });
  }

  // Reset credentials APIs
  generateResetPasswordToken(email: string) {
    return this.http.get(`${environment.apiUrl}/Authenticate/GenerateResetPasswordToken?email=${email}`);
  }
  verifyResetToken(userId: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/VerifyResetToken`, { userId, token });
  }
  resetPassword(password: string, userID: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/ResetPassword`, { password, userID, token });
  }


  GetUserDetails() {
    const user = this.currentUserValue || new User();
    this.http.get(`${environment.apiUrl}/Account/UserProfile`).subscribe((data: any) => {
      localStorage.setItem('authUser', JSON.stringify(user));
      setTimeout(() => {
        location.reload();
      }, 100);
    }, error => {
      this.logout();
    });
  }

  RefeshUserToken() {
    return this.http.post<any>(
      `${environment.apiUrl}/Authenticate/refresh-token`, {})
      .pipe(map(returnUser => {
        if (returnUser) {
          const user = { ...returnUser };
          this.currentUserSubject.next(returnUser);
          user.UserRoles = this.encryptPermissions(user?.UserRoles || []);
          localStorage.setItem('authUser', JSON.stringify(user));
          location.reload();
        } else {
          this.logout();
        }
      }));
  }

  get isOnline$() {
    return this.networkStatus.pipe(filter(Boolean));
  }
}
